<template>
  <div class="filter mb-2">
    <CategoryTabs ref="categoryTabs" :categories="categories" :on-search="clickCategoryTab" />
    <div class="mb-2 d-flex justify-center">
      <div v-if="!showFilter" fab large class="mx-2 button bg-color-primary" @click="showFilter = !showFilter">
        <v-icon large color="white">mdi-file-search-outline</v-icon>
        <span>{{ $t("search") }}</span>
      </div>
      <v-card v-if="showFilter" class="filter-mob d-flex flex-column">
        <div class="flex-grow-1">
          <div v-if="!filter">
            <div class="d-flex justify-space align-center">
              <v-btn @click="showFilter = !showFilter" class="ma-2" outlined large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <h3 class="ma-5">{{ $t("search") }}</h3>
            </div>
            <v-divider/>

            <v-list>
              <item
                :name="$t('category_name')"
                :value="query.category && query.category.name"
                menu="category"
                @change="e=>filter=e"
              />
              <v-divider/>

              <item
                :name="$t('item')"
                :value="query.genus && query.genus.name"
                menu="genus"
                @change="e=>filter=e"
              />
              <v-divider/>

              <item
                name="生産者"
                :value="query.farm && query.farm.name"
                menu="farm"
                @change="e=>filter=e"
              />
              <v-divider/>

              <v-divider/>

              <item
                :name="$t('delivery_date')"
                :value="query.date"
                menu="date"
                @change="e=>filter=e"
              />

              <v-divider/>

              <item
                :name="$t('stem_size')"
                :value="query.stem_size"
                menu="stem_size"
                @change="e=>filter=e"
              />
              <v-divider/>
            </v-list>
          </div>

          <div v-else-if="filter==='category'">
            <category :list="categories" @click="clickHandler" @back="filter=null"/>
          </div>

          <div v-else-if="filter==='genus'">
            <genus :list="list" @click="clickHandler" @back="filter=null"/>
          </div>

          <div v-else-if="filter==='farm'">
            <farm :list="farms" @click="clickHandler" @back="filter=null"/>
          </div>

          <div v-else-if="filter==='date'">
            <date :date="query.date" @click="clickHandler" @back="filter=null"/>
          </div>

          <div v-else-if="filter==='stem_size'">
            <stem-size :stem_size="query.stem_size" @click="clickHandler" @back="filter=null"/>
          </div>
        </div>

        <div v-if="!filter" class="d-flex justify-space-around mb-4">
          <v-btn color="#03A9F4" @click="clearFilter" outlined>{{ $t("clear") }}</v-btn>
          <v-btn class="blue" @click="search" style="width: 60%">{{ $t("search_for") }}</v-btn>
        </div>
      </v-card>
    </div>
    <div class="mb-4">
      <v-chip v-if="hasCategory" color="#008dec" close outlined @click:close="clearBy('category')" class="ma-2">
        {{ query.category.name }}
      </v-chip>
      <v-chip v-if="hasGenus" color="#008dec" close outlined @click:close="clearBy('genus')" class="ma-2">
        {{ query.genus.name }}
      </v-chip>
      <v-chip v-if="hasFarm" color="#008dec" close outlined @click:close="clearBy('farm')" class="ma-2">
        {{ query.farm.name }}
      </v-chip>
      <v-chip v-if="hasDate" color="#008dec" close outlined @click:close="clearBy('date')" class="ma-2">
        {{ formatDate }}
      </v-chip>
      <v-chip v-if="hasStemSize" color="#008dec" close outlined @click:close="clearByStemSize" class="ma-2">
        {{ formatStemSize }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import Item from "@/components/shop/products/FilterMobile/Item.vue";
import Category from "@/components/shop/products/FilterMobile/Category.vue";
import Genus from "@/components/shop/products/FilterMobile/Genus.vue";
import Farm from "@/components/shop/products/FilterMobile/Farm.vue";
import Date from "@/components/shop/products/FilterMobile/Date.vue";
import StemSize from "@/components/shop/products/FilterMobile/StemSize.vue";
import CategoryTabs from "@/components/shop/products/CategoryTabs.vue";
import { formatDate } from "../../../../plugins/i18n";

export default {
  components: {
    Item,
    Category,
    Genus,
    Farm,
    Date,
    StemSize,
    CategoryTabs
  },
  props: {
    list: {
      type: Array,
      default: null
    },
    farms: {
      type: Array,
      default: null
    },
    categories: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      showFilter: false,
      query: {
        category: null,
        genus: null,
        farm: null,
        color: null,
        date: null,
        stem_size: {
          min: null,
          max: null
        }
      },
      filter: null
    };
  },
  computed: {
    formatDate() {
      if (this.query.date === null) {
        return null;
      }
      return formatDate(this.query.date, "yyyy年mm月dd日");
    },
    formatStemSize() {
      let text = "";
      if (this.query.stem_size.min !== null) {
        text = `${text}${this.query.stem_size.min}cm`;
      }
      text = `${text}〜`;
      if (this.query.stem_size.max !== null) {
        text = `${text}${this.query.stem_size.max}cm`;
      }
      return text;
    },
    hasCategory() {
      return this.query.category !== null;
    },
    hasGenus() {
      return this.query.genus !== null;
    },
    hasFarm() {
      return this.query.farm !== null;
    },
    hasDate() {
      return this.query.date !== null;
    },
    hasStemSize() {
      return this.query.stem_size.min !== null || this.query.stem_size.max !== null;
    }
  },
  methods: {
    initialize() {
      if (this.$route.query.category_id) {
        this.clickHandler({
          key: "category",
          value: this.$store.state.searchQuery.categories
            .find(item => item.id === Number(this.$route.query.category_id)) ?? null
        });
      }
      if (this.$route.query.flower_genus_id) {
        this.clickHandler({
          key: "genus",
          value: this.$store.state.searchQuery.available_flower_genus
            .find(item => item.id === Number(this.$route.query.flower_genus_id)) ?? null
        });
      }
      if (this.$route.query.farm_id) {
        this.clickHandler({
          key: "farm",
          value: this.$store.state.searchQuery.available_farms
            .find(item => item.id === Number(this.$route.query.farm_id)) ?? null
        });
      }
      if (this.$route.query.delivery_date) {
        this.clickHandler({
          key: "date",
          value: this.$route.query.delivery_date
        });
      }
      const stem_size = {
        min: null,
        max: null
      };
      if (this.$route.query.stem_size_min) {
        stem_size.min = Number(this.$route.query.stem_size_min);
      }
      if (this.$route.query.stem_size_max) {
        stem_size.max = Number(this.$route.query.stem_size_max);
      }
      if (stem_size.min !== null || stem_size.max !== null) {
        this.clickHandler({
          key: "stem_size",
          value: stem_size
        });
      }
    },
    clickCategoryTab(e) {
      if (!e.value) {
        this.clearBy("category");
      } else {
        this.query.category = e;
        this.clickHandler(e);
        this.search();
      }
    },
    clickHandler(e) {
      this.query[e.key] = e.value;

      if (e.key !== "color") {
        this.filter = null;
      }
    },
    search() {
      this.showFilter = false;
      this.$refs.categoryTabs.clearTab();
      this.$emit("click", this.query);
    },
    clearFilter() {
      this.filter = null;
      this.query.category = null;
      this.query.genus = null;
      this.query.farm = null;
      this.query.color = null;
      this.query.date = null;
      this.query.stem_size.min = null;
      this.query.stem_size.max = null;
      this.$emit("change", { key: "clear" });
    },
    clearBy(key) {
      this.$refs.categoryTabs.clearTab();
      this.query[key] = null;
      this.search();
    },
    clearByStemSize() {
      this.query.stem_size.min = null;
      this.query.stem_size.max = null;
      this.search();
    }
  }
};
</script>

<style lang="scss">
.filter {
  .button {
    display: flex;
    position: fixed;
    bottom: 130px;
    right: 20px;
    flex-direction: column;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #eee;
    color: #fff;
    font-size: 10px;
    z-index: 100;
  }
}

.filter-mob {
  position: fixed;
  top: 50px;
  left: 0;
  background: white;
  z-index: 1;
  height: calc(100% - 105px);
  width: 100vw;
  overflow: auto;

  z-index: 2;

  &-font {
    font-weight: 500;
    font-size: 16px;

    color: #009688;
  }
}
</style>
